<template>
  <div class="card rounded-lg border-0 shadow-none">
    <div v-if="$slots.header" class="card-header rounded-top-lg p-5">
      <slot name="header" />
    </div>

    <div class="card-body p-5">
      <slot name="body" />
    </div>

    <div v-if="$slots.footer" class="card-footer py-5 px-7 rounded-bottom-lg">
      <slot name="footer" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/designSystem/style/main.scss";
@import "@/designSystem/Grid/cx-grid.scss";
</style>
